import { Avatar, Box, Typography } from '@mui/material'
import EntityAvatar from 'theme/components/Avatar/EntityAvatar'

const RenderOption = ({ props, option, theme }) => {
  const { key, id, ...rest } = props
  const userName = option.name || option.Name || `${option?.first_name || ''} ${option?.last_name || ''}`.trim()
  return (
    <>
      {option.image_512 || option.img_link || option.image_48 ? (
        <EntityAvatar name={userName} photoUrl={option?.image_512 || option.img_link || option.image_48} size="md" showName={false} />
      ) : (
        <Avatar style={{ marginRight: 8 }} />
      )}
      <Box sx={{ display: 'flex', flexDirection: 'column' }}>
        <Typography
          sx={{
            color: theme.palette.text.primary,
            fontSize: 11,
            width: '100%',
          }}
        >
          {userName}
        </Typography>
        {option?.role && (
          <Typography
            sx={{
              color: theme.palette.text.success,
              fontSize: 10,
              fontStyle: 'italic',
              fontWeight: 'bold',
              textAlign: 'left',
              width: '100%',
            }}
          >{`${option?.role}`}</Typography>
        )}
        <Typography
          sx={{
            color: theme.palette.text.primary,
            fontSize: 10,
            fontStyle: 'italic',
            textAlign: 'left',
            width: '100%',
          }}
        >
          {option.email || option.Email || ''}
        </Typography>
        {option?.title && (
          <Typography
            sx={{
              color: theme.palette.text.primary,
              fontSize: '11px',
              fontStyle: 'italic',
              textAlign: 'left',
              width: '100%',
            }}
          >{`${option?.title}`}</Typography>
        )}
      </Box>
    </>
  )
}
export default RenderOption
